module.exports = {
  'MONEY': 'Dinheiro',
  'CREDIT_CARD': 'Cartão de Crédito',
  'DEBIT_CARD': 'Cartão de Débito',
  'VOUCHER': 'Voucher',
  'OTHER': 'Outro'
}